import { supabase } from './supabaseClient';

const API_URL = process.env.REACT_APP_API_URL || '';

// Helper to get auth headers
const getAuthHeaders = async () => {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
  } catch {
    return { 'Content-Type': 'application/json' };
  }
};

export async function listOrgWallets(orgId) {
  try {
    const headers = await getAuthHeaders();
    // Use the /wallets (plural) endpoint to get all wallets
    const res = await fetch(`${API_URL}/api/org/${orgId}/wallets`, { headers });
    if (!res.ok) {
      console.error('[orgWallet] listOrgWallets failed:', res.status);
      return { data: [], error: null };
    }
    const json = await res.json();
    return { data: json.wallets || [], error: null };
  } catch (err) {
    console.error('[orgWallet] listOrgWallets error:', err);
    return { data: [], error: null };
  }
}

export async function createOrgWallet(wallet) {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/org/${wallet.org_id}/wallet/create`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        name: wallet.name,
        currency: wallet.currency || 'aUEC',
        is_primary: wallet.is_primary || false
      })
    });
    if (!res.ok) {
      const text = await res.text();
      console.error('[orgWallet] createOrgWallet failed:', res.status, text);
      return { data: null, error: { message: text } };
    }
    const json = await res.json();
    return { data: json.wallet || json, error: null };
  } catch (err) {
    console.error('[orgWallet] createOrgWallet error:', err);
    return { data: null, error: err };
  }
}

export async function listOrgTransactions(orgId, filters = {}) {
  try {
    const headers = await getAuthHeaders();
    const params = new URLSearchParams();
    if (filters.wallet_id) params.append('wallet_id', filters.wallet_id);
    if (filters.member_id) params.append('member_id', filters.member_id);
    if (typeof filters.confirmed === 'boolean') params.append('confirmed', filters.confirmed);

    const url = `${API_URL}/api/org/${orgId}/wallet/transactions${params.toString() ? '?' + params.toString() : ''}`;
    const res = await fetch(url, { headers });
    if (!res.ok) {
      console.error('[orgWallet] listOrgTransactions failed:', res.status);
      return { data: [], error: null };
    }
    const json = await res.json();
    return { data: json.transactions || [], error: null };
  } catch (err) {
    console.error('[orgWallet] listOrgTransactions error:', err);
    return { data: [], error: null };
  }
}

export async function createOrgTransaction(tx) {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/org/${tx.org_id}/wallet/transactions`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        kind: tx.kind,
        amount: tx.amount,
        currency: tx.currency || 'aUEC',
        note: tx.note || null,
        member_id: tx.member_id || null,
        wallet_id: tx.wallet_id || null,
        confirmed: tx.confirmed || false
      })
    });
    if (!res.ok) {
      const text = await res.text();
      console.error('[orgWallet] createOrgTransaction failed:', res.status, text);
      return { data: null, error: { message: text } };
    }
    const json = await res.json();
    return { data: json.transaction || json, error: null };
  } catch (err) {
    console.error('[orgWallet] createOrgTransaction error:', err);
    return { data: null, error: err };
  }
}

export async function createOrgTransactionsBulk(txs) {
  // For bulk transactions, call the single endpoint multiple times
  // (or implement a bulk endpoint later)
  if (!Array.isArray(txs) || txs.length === 0) return { data: [], error: null };

  const results = [];
  for (const tx of txs) {
    const { data, error } = await createOrgTransaction(tx);
    if (data) results.push(data);
    if (error) console.error('[orgWallet] bulk tx error:', error);
  }
  return { data: results, error: null };
}

export async function confirmOrgTransaction(id, orgId) {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/org/${orgId}/wallet/transactions/${id}/confirm`, {
      method: 'PUT',
      headers
    });
    if (!res.ok) {
      const text = await res.text();
      console.error('[orgWallet] confirmOrgTransaction failed:', res.status, text);
      return { data: null, error: { message: text } };
    }
    const json = await res.json();
    return { data: json.transaction || json, error: null };
  } catch (err) {
    console.error('[orgWallet] confirmOrgTransaction error:', err);
    return { data: null, error: err };
  }
}
